import React, { useState } from 'react'
import Footer from './footer';
import './consulta-reserva.css';
import { notification } from './util/NotificationManager';
import NotificationContainer from './NotificationContainer';
import { Helmet } from 'react-helmet-async';

export default function Reserva() {
    const [email, setEmail] = useState('');
    const [reservationNumber, setReservationNumber] = useState('');
    const [reservationDetails, setReservationDetails] = useState(null);
    const [error, setError] = useState('');
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,63}$/;

    const consultaReserva = async (e) => {
      e.preventDefault()
      if (email === '' || reservationNumber ==='') {
        notification('Por favor, complete todos los campos',"error", 5000);
        return;
      }
      try {
        //console.log("Datos enviados: "+ email + " -- "+reservationNumber)
        // Hacer la solicitud al backend
        const response = await fetch(`${process.env.REACT_APP_URL_BACKEND}/estado-reservas`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ 
            email: email,
             resNumber: reservationNumber }),
        });
  
        // Verificar si la respuesta fue exitosa
        if (!response.ok) {
          if (response.status === 404) {
            notification('No se encontró ninguna reserva con la información proporcionada',"error", 5000);
          } else {
            throw new Error('Error al realizar la consulta');
          }
          setReservationDetails(null); // Asegurarse de limpiar el resultado anterior
          return;
        }
        //console.log(response)
        const data = await response.json(); // Asumimos que el backend retorna JSON
        //console.log(data)

        if (!data || Object.keys(data).length === 0) {
          notification('No se encontró ningún usuario con los datos proporcionados.',"error", 5000);
          setReservationDetails(null);
        } else {
          setReservationDetails(data);
        }
      } catch (error) {
        console.error(error);
        notification('Hubo un error al realizar la consulta.',"error", 5000);
        setReservationDetails(null); // Limpiar el resultado si hay error
      }
    }

    const handleEmailChange = (e) => {
        const value = e.target.value;
        setEmail(value);
      
        // Validar el correo
        if (value === '') {
          setError('El correo no puede estar vacío.');
        } else if (!emailPattern.test(value)) {
          setError('Por favor, ingresa un correo electrónico válido.');
        } else {
          setError('');
        }
      };

      const formatearFecha = (date, hora) => {  //Dar formato
        const dateFormato = date.toLocaleDateString('es-ES', { weekday: 'long', day: 'numeric', month: 'long' })

        const horaFormato = hora.slice(0, -3); // Formato "HH:00"
        const fecha = dateFormato+" a las "+horaFormato;
        return fecha
      }



    return (
      <>
        <Helmet>
          <title>Consulta tu reserva</title>
        </Helmet>
        <div className='contenedor-pagina'>
          <NotificationContainer/>
          <div className="Contenedor-Consulta-Reserva">
          <h1>Consulta tu reserva</h1>
          <form
              onSubmit={consultaReserva}
              className="Form-Consulta-Reserva"
          >
              <label>
                  Correo Electronico:
                  <input
                  type="email"
                  id='email'
                  placeholder="ejemplo@correo.com"
                  value={email}
                  onChange={handleEmailChange}
                  />
                  {error && <p style={{ color: '#D90429' }}>{error}</p>}
              </label>
              <label>
                  Número de Reserva:
                  <input
                  type="text"
                  placeholder="012345"
                  pattern='\d{3,}'
                  title='Ingrese un número de reserva valido'
                  value={reservationNumber}
                  onChange={(e) => setReservationNumber(e.target.value)}
                  required
                  />
              </label>
              <button type="submit">Consultar</button>
          </form>

          {reservationDetails && (
              <div className="Detalles-Reserva">
              <h2>Detalles de la reserva</h2>
              <ul>
                  <li><strong>Cliente:</strong> {reservationDetails.nombre_cliente}</li>
                  <li><strong>Telefono del cliente:</strong> {reservationDetails.telefono_cliente}</li>
                  <li><strong>Establecimiento:</strong> {reservationDetails.nombre_establecimiento}</li>
                  <li><strong>Dirección:</strong> {reservationDetails.direccion}</li>
                  <li><strong>Teléfono del establecimiento:</strong> {reservationDetails.telefono}</li>
                  <li><strong>Estado de la reserva:</strong>&nbsp;<span className={`reserva-estado ${reservationDetails.estado}`}>{reservationDetails.estado}</span></li>
                  <li><strong>Tipo de cancha:</strong> Fut {reservationDetails.tipo_cancha}</li>
                  <li><strong>Cancha asignada:</strong>{" "} {reservationDetails.nombre_cancha || "Pendiente de confirmar"}</li>
                  <li><strong>Fecha de la reserva:</strong> {formatearFecha(new Date(reservationDetails.dia),reservationDetails.hora)}</li>
              </ul>
              </div>
          )}
          
          </div>
          <Footer/>
        </div>
      </> 
    )
}